import {useMutation, useQuery} from '@tanstack/react-query'

import {useApi} from 'hooks'
import {cacheKeys} from 'api'

const usePopUp = () => {
  const api = useApi()

  const {data, refetch: refetchShowPopUp} = useQuery([cacheKeys.showPopUp], () =>
    api.showPopUp({content_id: 1}),
  )

  const {mutate: disablePopUp, isLoading: disablePopUpLoading} = useMutation(
    () => api.disablePopUp({content_id: 1}),
    {
      onSuccess: () => {
        refetchShowPopUp()
      },
    },
  )

  return {
    success: data && data.success,
    refetchShowPopUp,
    disablePopUp,
    disablePopUpLoading,
  }
}

export default usePopUp
